import { gql } from "gql";

export const GET_COMPANY_DOCUMENT_FOLDER_TREE = gql(/* GraphQL */ `
  query GetCompanyDocumentFolderTree {
    getCompanyDocumentTree {
      id
      parentId
      __typename
      ... on CompanyDocumentFolderNodeDto {
        folder {
          ... on CompanyDocumentFolderDto {
            id
            ...CompanyDocumentFolderName
            ...CompanyDocumentFolderColor
          }
          ... on Hidden {
            ...Hidden
          }
        }
      }
    }
  }
`);
